// Production: Use pre-compiled Elm JS (built by npm run build:elm-precompile)
export { Elm } from "./.elm-precompiled.js";
